function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  d: "M0 0h56v56H0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#logo_svg__paint0_linear)",
  d: "M0 0h56v56H0z",
  opacity: 0.5
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 28,
  fill: "url(#logo_svg__paint1_linear)",
  opacity: 0.5
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28 0l28 56H0L28 0z",
  fill: "url(#logo_svg__paint2_linear)",
  opacity: 0.5
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.853 40h4.18l-7.7-9.68 7.626-8.03h-4.143l-8.543 8.983v-15.73h-3.3V40h3.3v-4.913l2.676-2.714L91.853 40z",
  fill: "url(#logo_svg__paint3_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M97.027 31.127c0 5.573 3.887 9.313 9.167 9.313 2.86 0 5.353-.916 7.113-2.64l-1.54-2.163c-1.32 1.356-3.373 2.09-5.243 2.09-3.557 0-5.757-2.493-6.014-5.5h14.007v-.807c0-5.427-3.3-9.57-8.617-9.57-5.17 0-8.873 4.143-8.873 9.277zm8.873-6.563c3.74 0 5.317 2.933 5.39 5.28h-10.816c.183-2.42 1.87-5.28 5.426-5.28z",
  fill: "url(#logo_svg__paint4_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.278 43.96l-.513 2.97c.513.147 1.503.257 2.053.257 2.567-.037 4.51-1.027 5.647-3.813l8.726-21.084h-3.556l-5.537 13.897-5.537-13.897h-3.52l7.297 17.894-1.027 2.346c-.55 1.32-1.356 1.724-2.566 1.724-.44 0-1.064-.11-1.467-.294z",
  fill: "url(#logo_svg__paint5_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M136.87 40h3.3V27.68c.77-1.32 3.007-2.567 4.657-2.567.44 0 .807.037 1.137.11v-3.336c-2.347 0-4.437 1.357-5.794 3.116V22.29h-3.3V40z",
  fill: "url(#logo_svg__paint6_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.213 40h3.3V22.29h-3.3v12.724c-.99 1.32-2.86 2.493-4.913 2.493-2.274 0-3.74-.88-3.74-3.813V22.29h-3.3v12.504c0 3.74 1.87 5.646 5.646 5.646 2.714 0 4.95-1.393 6.307-2.86V40z",
  fill: "url(#logo_svg__paint7_linear)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M173.042 46.747v-9.313c1.43 1.943 3.483 3.006 5.793 3.006 4.62 0 7.883-3.52 7.883-9.313 0-5.793-3.263-9.277-7.883-9.277-2.383 0-4.51 1.21-5.793 2.97v-2.53h-3.3v24.457h3.3zm10.23-15.62c0 3.703-2.017 6.38-5.317 6.38-2.017 0-4.033-1.21-4.913-2.603v-7.517c.88-1.43 2.896-2.604 4.913-2.604 3.3 0 5.317 2.677 5.317 6.344z",
  fill: "url(#logo_svg__paint8_linear)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M195.78 40.44c1.724 0 2.75-.476 3.447-1.136l-.843-2.494c-.33.367-1.027.697-1.797.697-1.137 0-1.723-.917-1.723-2.163V25.186h3.593V22.29h-3.593v-4.84h-3.3v4.84h-2.934v2.897h2.934v10.89c0 2.787 1.43 4.363 4.216 4.363z",
  fill: "url(#logo_svg__paint9_linear)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M202.111 40h3.3V22.29h-3.3V40z",
  fill: "url(#logo_svg__paint10_linear)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M215.363 40h3.556l7.297-17.71h-3.557l-5.536 13.897-5.537-13.897h-3.52L215.363 40z",
  fill: "url(#logo_svg__paint11_linear)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M227.795 31.127c0 5.573 3.887 9.313 9.167 9.313 2.86 0 5.353-.916 7.113-2.64l-1.54-2.163c-1.32 1.356-3.373 2.09-5.243 2.09-3.557 0-5.757-2.493-6.013-5.5h14.006v-.807c0-5.427-3.3-9.57-8.617-9.57-5.17 0-8.873 4.143-8.873 9.277zm8.873-6.563c3.74 0 5.317 2.933 5.391 5.28h-10.817c.183-2.42 1.87-5.28 5.426-5.28z",
  fill: "url(#logo_svg__paint12_linear)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M203.724 19.32c1.174 0 2.127-.916 2.127-2.09a2.128 2.128 0 0 0-2.127-2.127c-1.136 0-2.126.954-2.126 2.127 0 1.174.99 2.09 2.126 2.09z",
  fill: "#000"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M203.726 19.324c1.174 0 2.127-.917 2.127-2.09a2.128 2.128 0 0 0-2.127-2.127c-1.136 0-2.126.953-2.126 2.127 0 1.173.99 2.09 2.126 2.09z",
  fill: "url(#logo_svg__paint13_linear)",
  opacity: 0.7
});

var _ref17 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "logo_svg__paint0_linear",
  x1: 0,
  y1: 0,
  x2: 56,
  y2: 56,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint1_linear",
  x1: 0,
  y1: 0,
  x2: 56,
  y2: 56,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint2_linear",
  x1: 0,
  y1: 0,
  x2: 56,
  y2: 56,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint3_linear",
  x1: 79.973,
  y1: 15.543,
  x2: 91.659,
  y2: 76.593,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0577DF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0000DF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint4_linear",
  x1: 79.973,
  y1: 15.543,
  x2: 91.659,
  y2: 76.593,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0577DF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0000DF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint5_linear",
  x1: 79.973,
  y1: 15.543,
  x2: 91.659,
  y2: 76.593,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0577DF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0000DF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint6_linear",
  x1: 79.973,
  y1: 15.543,
  x2: 91.659,
  y2: 76.593,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0577DF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0000DF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint7_linear",
  x1: 79.973,
  y1: 15.543,
  x2: 91.659,
  y2: 76.593,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0577DF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0000DF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint8_linear",
  x1: 79.973,
  y1: 15.543,
  x2: 91.659,
  y2: 76.593,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0577DF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0000DF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint9_linear",
  x1: 79.973,
  y1: 15.543,
  x2: 91.659,
  y2: 76.593,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0577DF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0000DF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint10_linear",
  x1: 79.973,
  y1: 15.543,
  x2: 91.659,
  y2: 76.593,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0577DF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0000DF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint11_linear",
  x1: 79.973,
  y1: 15.543,
  x2: 91.659,
  y2: 76.593,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0577DF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0000DF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint12_linear",
  x1: 79.973,
  y1: 15.543,
  x2: 91.659,
  y2: 76.593,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0577DF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0000DF"
})), React.createElement("linearGradient", {
  id: "logo_svg__paint13_linear",
  x1: 201.6,
  y1: 15.107,
  x2: 205.816,
  y2: 19.36,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.292,
  stopColor: "#94B0FF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#3269FF"
})));

var SvgLogo = function SvgLogo(props) {
  return React.createElement("svg", _extends({
    width: 246,
    height: 56,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

export default "data:image/svg+xml;base64,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";
export { SvgLogo as ReactComponent };